import { CurrencyDisplay, StatusChip } from "components";
import { formatDate, textCapitalization } from "utils";
import { chipInvoiceStatus } from "../../../Publisher/Invoice/Components/ConstantInvoice";

export const columnTableDashboard = print => [
  {
    name: "song_title",
    title: "Song title",
    renderText: item => item || "-",
  },
  {
    name: "stream",
    title: "Listener Traffic",
    headerAlign: "right",
    useSort: !print,
    sort_key: !print && "stream",
    renderText: item => <CurrencyDisplay value={item} />,
  },
  {
    name: "revenue",
    title: "Revenue",
    headerAlign: "right",
    useSort: !print,
    sort_key: !print && "revenue",
    renderText: item => (
      <CurrencyDisplay value={item} prefix="Rp" decimalScale={2} />
    ),
  },
];
export const columnTableInvoice = isexporting => [
  {
    name: "date",
    title: "Date",
    renderText: item => formatDate(item),
  },
  {
    name: "invoice_number",
    title: "Invoice Number",
    renderText: item => item || "-",
  },
  {
    name: "payment_number",
    title: "Payment Number",
    renderText: item => item || "-",
  },
  {
    name: "note",
    title: "Description",
    renderText: item => item || "-",
  },
  {
    name: "value",
    headerAlign: "right",
    title: "Value",
    renderText: item => (
      <CurrencyDisplay value={item} prefix="Rp" decimalScale={2} />
    ),
  },
  {
    name: "status",
    title: "Status",
    renderText: status => {
      const selectedStatus = chipInvoiceStatus?.find(
        item => item?.value === status
      );
      return (
        <StatusChip
          label={selectedStatus?.name || textCapitalization(status) || "-"}
          type={selectedStatus?.color}
          isExporting={isexporting || false}
        />
      );
    },
  },
];
